<template>
  <div class="container">
    <!-- 导航菜单栏 -->
    <nav-bar v-if="!isShowProjList"></nav-bar>
    <!-- 头部区域 -->
    <head-bar></head-bar>
    <!-- 主内容区域 -->
    <main-content v-if="!isShowProjList"></main-content>
    <project-selection v-if="isShowProjList"></project-selection>
  </div>
</template>

<script>
import HeadBar from "./HeadBar";
import NavBar from "./NavBar";
import MainContent from "./MainContent";
import ProjectSelection from "./Tbim/ProjectSelection.vue";
import { mapState } from "vuex";
export default {
  components: {
    HeadBar,
    NavBar,
    MainContent,
    ProjectSelection,
  },
  computed: {
    ...mapState({
      isShowProjList: (state) => state.tbim.isShowProjList,
    }),
  },
};
</script>

<style scoped lang="scss">
.container {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  // background: rgba(224, 234, 235, 0.1);
}
</style>  


// WEBPACK FOOTER //
// src/views/Home.vue